<template>
<div>
  <v-map :init-data="initData" v-if="showMap"></v-map>

  <static-map
    v-else-if="mapInitializationGuardType == 'static_map' && staticMapUrlTemplate"
    @static-map-clicked="activateMap"
    :name="name"
    :url-template="staticMapUrlTemplate"
    :callToActionType="mapInitializationGuardCallToAction"
  ></static-map>

  <custom-map-guard-image
    v-else-if="mapInitializationGuardType == 'image' && customMapGuardImageUrl"
    @custom-image-clicked="activateMap"
    :name="name"
    :url="customMapGuardImageUrl"
    :callToActionType="mapInitializationGuardCallToAction"
  ></custom-map-guard-image>

  <div v-else>
    <div v-bind:style="backgroundStyle">
      <div v-bind:style="overlay"></div>
      <div class="h-100 row align-items-center">
        <div class="d-flex col justify-content-center">
          <button
            type="button"
            @click="activateMap"
            id="map-activation-button"
            class="text-xl btn btn-light btn-lg"
            style="padding-top: 20px; padding-bottom: 20px;"
          >
            <i class="fas fa-play-circle"></i>
            Load {{name}}
          </button>
        </div>
      </div>
      <div class='text'>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import vMap from './vector_map/map';
import backgroundImage from '../images/topo.png';
import staticMap from './static_map';
import customMapGuardImage from './custom_map_guard_image';

export default {
  components: { vMap, staticMap, customMapGuardImage },

  props: ['initData'],

  computed: {
    showMap() {
      return !this.mapInitializationGuardEnabled || this.mapInitialized;
    }
  },

  data() {
    const opts = JSON.parse(this.initData);

    return {
      mapInitialized: false,
      mapInitializationGuardEnabled: opts.feature_set.map_initialization_guard.enabled,
      mapInitializationGuardType: opts.feature_set.map_initialization_guard.type,
      mapInitializationGuardCallToAction: opts.feature_set.map_initialization_guard.call_to_action,
      name: opts.meta ? opts.meta.name : 'Unknown route',
      customMapGuardImageUrl: opts.meta ? opts.meta.custom_map_guard_image_url : null,
      staticMapUrlTemplate: opts.meta ? opts.meta.static_map_url_template : null,
      isSandbox: opts.sandbox || false,
      backgroundStyle: {
        "position": 'relative',
        "background-color": '#343a40',
        "background": `url(${backgroundImage}) no-repeat center center`,
        "background-size": "cover",
        "padding": '8rem',
        "height": '100vh'
      },
      overlay: {
        "position": "absolute",
        "height": "100%",
        "width": "100%",
        "top": 0,
        "left": 0,
        "background-color": "rgba(0, 0, 0, 0.7)"
      }
    }
  },

  mounted() {
    if (this.isSandbox) {
      this.$toasted.info('This is a preview available only to you. Do not use this URL to share your course.', {
        duration: 8000,
        position: 'top-center',
        action: {
          text: 'Dismiss',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        }
      });
    }
  },

  methods: {
    activateMap() {
      this.mapInitialized = true;
    }
  }

}
</script>
